import { isEmpty, isNil } from 'lodash';

import { QuestionnaireModel } from 'api/backofficeApiClient';

export interface Questionnaire {
  closedQuestion?: boolean;
  comment?: string;
}

const emptyQuestionnaireElement: Questionnaire = {
  closedQuestion: undefined,
  comment: '',
};

export const mapQuestionnaireToRequest = (
  questionnaireElement: Questionnaire,
) => {
  const { comment, closedQuestion } = questionnaireElement;

  const questionnaire: QuestionnaireModel = {};

  !!comment && (questionnaire.comment = comment);
  !isNil(closedQuestion) && (questionnaire.isValue = closedQuestion);

  return isEmpty(questionnaire) ? undefined : questionnaire;
};

export const mapQuestionnaireToInitialValues = (
  questionnaireElement?: QuestionnaireModel,
) => {
  if (!questionnaireElement) return emptyQuestionnaireElement;

  const { isValue, comment } = questionnaireElement;

  const questionnaire: Questionnaire = {};

  !isNil(isValue) && (questionnaire.closedQuestion = isValue);
  !!comment && (questionnaire.comment = comment);

  return isEmpty(questionnaire) ? emptyQuestionnaireElement : questionnaire;
};
